import { render, staticRenderFns } from "./PpeHome.vue?vue&type=template&id=67a3a635&scoped=true&"
import script from "./PpeHome.vue?vue&type=script&lang=js&"
export * from "./PpeHome.vue?vue&type=script&lang=js&"
import style0 from "./PpeHome.vue?vue&type=style&index=0&id=67a3a635&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3a635",
  null
  
)

export default component.exports